<template>
    <span class="w-full block border-b-1 border-gray-l-200" />
</template>
